var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.52712,
    cy: 5.59126,
    rx: 5.44363,
    ry: 5.59126,
    fill: "#EB001B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0596,
    cy: 5.59138,
    rx: 5.44363,
    ry: 5.59126,
    fill: "#F79E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7933 10.0644C10.296 9.17153 11.3071 7.50272 11.3071 5.59136C11.3071 3.68001 10.296 2.0112 8.7933 1.11835C7.29057 2.0112 6.27954 3.68001 6.27954 5.59136C6.27954 7.50272 7.29057 9.17153 8.7933 10.0644Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.37efe16a8b3cbbaafbe92b69143e0374.svg";
export { ForwardRef as ReactComponent };